import { instance } from "../axiosConfig";

export const getKakaoCallback = (code) => instance.get(`/auth/login/kakao/callback?code=${code}`);

export const getKakaoLogout = () => instance.get(`/auth/login/kakao/logout`);
export const getKakaoUnlink = () => instance.get(`/auth/login/kakao/unlink`);

